module.exports = __webpack_public_path__ + "static/media/dynamic_maize_production.ac760eda.pdf";